var React = require('react');

function IconYoutube (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"arrowMask","key":0},[React.createElement("rect",{"x":"0","y":"0","width":"100","height":"100","fill":"white","key":0}),React.createElement("path",{"d":"M47.176 25L28.588 14.294v21.412z","fill":"black","key":1})]),React.createElement("path",{"d":"M69.941 7.824a8.95 8.95 0 0 0-6.294-6.294C58.059 0 35.706 0 35.706 0S13.353 0 7.765 1.471c-3 .824-5.471 3.294-6.294 6.353C0 13.412 0 25 0 25s0 11.647 1.471 17.176a8.95 8.95 0 0 0 6.294 6.294C13.412 50 35.706 50 35.706 50s22.353 0 27.941-1.471a8.95 8.95 0 0 0 6.294-6.294c1.471-5.588 1.471-17.176 1.471-17.176s.059-11.647-1.471-17.235z","fill":"currentColor","mask":"url(#arrowMask)","key":1})]);
}

IconYoutube.defaultProps = {"width":"71.412","height":"50","viewBox":"0 0 71.412 50"};

module.exports = IconYoutube;

IconYoutube.default = IconYoutube;
